<!--
반품비용 과금 — 래퍼 컴포넌트
------------------------------------
환율 입력 + 과금 진행상황을 인라인으로 표시한다.
-->
<template>
<div class="">
    <charge
        ref="charge"
        :item-count="itemCount"
        :csrfToken="csrfToken"
        :region-id="regionId"
        :return-done-date="returnDoneDate"
        :region-currency="regionCurrency"
    ></charge>
</div>
</template>

<script>
    export default {
        components: {
            'charge': require('./charge.vue').default,
        },
        props: {
            /**
             * 과금 대상 건수
             */
            itemCount: {
                type: Number,
                default: 0,
            },

            // csrf-token
            csrfToken: String,
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
            /**
             * 반품완료일
             */
            returnDoneDate: {
                type: String,
                default: null,
            },
            /**
             * 지역통화
             */
            regionCurrency: {
                type: String,
                default: null,
            },
        },
        data: function () {
            return {
            };
        },
        computed: {
        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>
